import { render, staticRenderFns } from "./face-radio.vue?vue&type=template&id=1a82fb21&scoped=true&"
import script from "./face-radio.vue?vue&type=script&lang=ts&"
export * from "./face-radio.vue?vue&type=script&lang=ts&"
import style0 from "./face-radio.vue?vue&type=style&index=0&id=1a82fb21&prod&lang=scss&scoped=true&"
import style1 from "./face-radio.vue?vue&type=style&index=1&id=1a82fb21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82fb21",
  null
  
)

export default component.exports